import "./cookie";

document.addEventListener("DOMContentLoaded", () => {
	const isFrontPage = document.body.classList.contains("home");
	const swiperExists = typeof Swiper !== undefined;

	AOS.init({
		disable: "mobile",
		ease: "ease-in-out",
		duration: 500,
		once: true,
	});

	if (isFrontPage && swiperExists) {
		new Swiper(".homeSlider", {
			loop: true,
			autoplay: {
				delay: 4000,
				pauseOnMouseEnter: true,
			},
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
	}

	const handleMobileMenu = () => {
		const menuTriggers = [...document.querySelectorAll(".menu-trigger")];
		if (!menuTriggers) throw new Error("Missing element");

		const mobileMenu = document.querySelector(".container__navMobile");
		if (!mobileMenu) throw new Error("Missing element");

		const navAnchors = [
			...mobileMenu.querySelectorAll(".navMobile__menuContainer a"),
		];

		/**
		 * Permettre l'ouverture/fermeture du menu quand on clique sur un trigger
		 */
		menuTriggers.forEach((button) => {
			button.onclick = () => {
				mobileMenu.classList.toggle("open");
			};
		});

		/**
		 * Permettre la fermeture du menu quand on clique sur une ancre du menu
		 */
		navAnchors.forEach((a) => {
			a.onclick = () => {
				mobileMenu.classList.remove("open");
			};
		});

		/**
		 * Permettre la fermeture du menu quand il est ouvert et qu'on clique ailleurs
		 */
		document.onclick = (e) => {
			// Early return si le menu n'est pas ouvert
			if (!mobileMenu.classList.contains("open")) return;

			// Early return si e.target est un menu trigger et n'est pas un trigger de fermeture
			for (const t of menuTriggers) {
				if (e.target === t && !t.classList.contains("close")) return;
			}

			mobileMenu.classList.remove("open");
		};
	};

	handleMobileMenu();
	window.onresize = handleMobileMenu;
});
